import { AxiosResponse } from "axios";
import { GetAllVendorsListApiResponse } from "../../@types/DRO/GetAllVendorsResponse";
import { CreateVendorBody } from "../../@types/DTO/CreateVendorBody";
import { erpAxios, getAuthToken } from "../axiosInstances";

export class GetAllVendorsListApi {
  public static api = new GetAllVendorsListApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async getAllVendorsList(
    page: number = 0,
    pageSize: number = 10,
    search: string = "",
    startDate?: string,
    endDate?: string,
    enabled?: boolean
  ): Promise<GetAllVendorsListApiResponse> {
    try {
      const response: AxiosResponse<GetAllVendorsListApiResponse> =
        await this.instance.get("/erp/api/v1/vendor/all", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params: {
            page,
            pageSize,
            search,
            startDate,
            endDate,
            enabled,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching vendor data", error);
      throw error;
    }
  }

  async createVendor(orderBody: CreateVendorBody): Promise<void> {
    try {
      await this.instance.post(`/erp/api/v1/vendor/add`, orderBody, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
    } catch (error) {
      throw error;
    }
  }

  async changeVendorStatus(id: number): Promise<void> {
    try {
      await this.instance.put(
        `/erp/api/v1/vendor/${id}/status-change`,
        null,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
    } catch (error) {
      console.error("Error changing vendor status", error);
      throw error;
    }
  }
}
